<template>
  <vue-apex-charts
    class="comBarChart"
    ref="competitionChartBar"
    type="bar"
    height="500"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

export default {
  name: "CompetitionChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsBar: {
        chart: {
          height: 390,
          type: "bar",
          background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          }
        },
        grid:{
          show: true,
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          // textAnchor: 'start',
          position: 'bottom',
          offsetY: 0,
          style: {
            colors: ['#FFFFFF'],
          },
          formatter: function (val, opt) {
            return Math.round(val) + "%"
          },
          dropShadow: {
            enabled: false
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            show: true
          },
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
        },
        plotOptions: {
          bar: {
                barHeight: '100%',
                distributed: true,
                horizontal: false,
                dataLabels: {
                  position: 'center'
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#404040',
            fontSize: '20px',
            fontFamily: "NanumBarunGothic"
          }
        },
        colors: [
          function({ value, seriesIndex, w }) {
            if(w.globals.labels[seriesIndex] == '김문수'){
              return '#E60024'
            }else if(w.globals.labels[seriesIndex] == '이재명'){
              return '#162583'
            }else if(w.globals.labels[seriesIndex] == '이준석'){
              return '#FF7920'
            }else if(w.globals.labels[seriesIndex] == '권영국'){
              return '#F5EB1B'
            }else if(w.globals.labels[seriesIndex] == '구주와'){
              return '#E96B6F'
            }else if(w.globals.labels[seriesIndex] == '황교안' || w.globals.labels[seriesIndex] == '송진호'){
              return '#ADAEB3'
            }else if(w.globals.labels[seriesIndex] == '기타'){
              return '#808080'
            }else{
              return '#A5BFFF';
            }
          }
        ],
      },
      series: [{
        data: []
      }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    totalFreq: {
      type: Number,
      default: 0
    },
    partyList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    barChartData() {
      const newData = []
      const newFreq = []
      const newParty = []
      for (const data of this.barChartData) {
        newData.push(data.rate);
        newFreq.push(data.freq);
        newParty.push(data.party)
      }

      const newCategory = []
      // for (const data of this.barChartCategory) {
      //     newCategory.push(data);
      // }
      for (const [ index, data ] of this.barChartCategory.entries()) {      
        newCategory.push([data, newParty[index]]);
      }
      this.setValues(newData, newCategory, this.totalFreq, newParty, newFreq)
    },
  },

  methods:{
    setHeight(value) {
      this.barChartHeight = value
    },
    setValues(newData, newCategory, totalFreq, partyList, newFreq){
      this.chartOptionsBar.xaxis = {
          categories: newCategory,
          labels:{
            maxHeight: "auto",
            show: true,
          },
        }
      this.series = [{
          data: newData
        }]      
      // this.chartOptionsBar.tooltip = {
      //   followCursor: true,
      //   enabled: true,
      //   fixed: {
      //     enabled: false,
      //   },
      //   x: {
      //     show: true
      //   },
      //   y: {
      //     formatter(val, w){
      //       return Math.round(newFreq[w.dataPointIndex]).toLocaleString()
      //     },
      //     title: {
      //       formatter: function () {
      //         return ''
      //       }
      //     },
      //   },
      // }
      this.chartOptionsBar.tooltip = {
          followCursor: true,
          shared: false,
          intersect: true,
          enabled: true,
          fixed: {
            enabled: false,
          },
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            console.log('@#@#@#@#@#')
            console.log(dataPointIndex)
            var color = ''
            if(partyList[dataPointIndex] == '국민의힘'){
              color = '#E60024'
            }else if(partyList[dataPointIndex] == '더불어민주당'){
              color = '#162583'
            }else if(partyList[dataPointIndex] == '개혁신당'){
              color = '#FF7920'
            }else if(partyList[dataPointIndex] == '진보당'){
              color = '#A30617'
            }else if(partyList[dataPointIndex] == '정의당'){
              color = '#FFED00'
            }else if(partyList[dataPointIndex] == '조국혁신당'){
              color = '#1F96DE'
            }else if(partyList[dataPointIndex] == '자유와혁신'){
              color = '#830029'
            }else if(partyList[dataPointIndex] == '기본소득당'){
              color = '#00FFDF'
            }else if(partyList[dataPointIndex] == '새미래민주당'){
              color = '#4FB4B9'
            }else if(partyList[dataPointIndex] == '무소속'){
              color = '#ADAEB3'
            }else{
              color = '#A5BFFF';
            }

            var val = Math.round(newFreq[dataPointIndex]).toLocaleString()

            return '<div class="custom-tooltip">' +
                    '<span style="background-color: ' + color + '; width: 10px; height: 10px; display: inline-block;"></span>' +
                    '<span class="apexcharts-tooltip-text"> ' + val + ' </span>' +
                    '</div>';
          },
        },




      this.chartOptionsBar.colors = [
          function({ value, seriesIndex, w }) {
            if(partyList[seriesIndex] == '국민의힘'){
              return '#E60024'
            }else if(partyList[seriesIndex] == '더불어민주당'){
              return '#162583'
            }else if(partyList[seriesIndex] == '개혁신당'){
              return '#FF7920'
            }else if(partyList[seriesIndex] == '진보당'){
              return '#A30617'
            }else if(partyList[seriesIndex] == '정의당'){
              return '#FFED00'
            }else if(partyList[seriesIndex] == '조국혁신당'){
              return '#1F96DE'
            }else if(partyList[seriesIndex] == '자유와혁신'){
              return '#830029'
            }else if(partyList[seriesIndex] == '기본소득당'){
              return '#00FFDF'
            }else if(partyList[seriesIndex] == '새미래민주당'){
              return '#4FB4B9'
            }else if(partyList[seriesIndex] == '무소속'){
              return '#ADAEB3'
            }else{
              return '#A5BFFF';
            }
          }
        ]
      // this.chartOptionsBar.tooltip.marker = {
      //   fillColors: [
      //       "#000000"
      //   ]
      // }

      
      this.$refs.competitionChartBar.updateOptions(this.chartOptionsBar, true);
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.comBarChart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.comBarChart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.comBarChart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}

.comBarChart svg{
  height: 480px;
}

// div.apexcharts-tooltip.apexcharts-theme-light > div > span:nth-child(2) {
//   font-family: 'NanumBarunGothic', sans-serif !important;
//   font-size: 12px !important;
// }

</style>
